import repository from "../Repository";

export default {
  async entry(screenId, payload) {
    return await repository.post("car/mount-equipment-entry", payload, {
      headers: {
        s: screenId
      }
    });
  },
  async update(screenId, payload) {
    return await repository.post("car/mount-equipment-update", payload, {
      headers: {
        s: screenId
      }
    });
  },
  async delete(screenId, payload) {
    return await repository.post("car/mount-equipment-delete", payload, {
      headers: {
        s: screenId
      }
    });
  }
};
